<template>
  <span>
    <span>{{params.label}}</span>
    <br v-if="params.subLabel"/>
    <span v-if="params.subLabel" style="font-weight: normal">{{params.subLabel}}</span>
  </span>
</template>

<script>
  export default {
    name: 'LabelCellRenderer',
    data() {
    },
    methods: {
    },
    mounted() {
      //console.log('LabelCellRenderer'); // uncomment to see how often component is rendering
    }
  }
</script>

<style scoped lang="scss">
</style>
